<ng-container *ngIf="config">
  <nz-form-item *ngIf="config">
    <nz-form-label [nzSpan]="6">默认值</nz-form-label>
    <nz-form-control>
      <input nz-input #nameInput="ngModel" name="value" type="text" [(ngModel)]="config.value" />
    </nz-form-control>
  </nz-form-item>

  <nz-form-item>
    <nz-form-label [nzSpan]="6">字典配置</nz-form-label>
    <nz-form-control nzSpan="24">
      <nz-table nzSize="small">
        <ng-container *ngIf="data.dataSource.length">
          <tr *ngFor="let item of data.dataSource; let i = index">
            <td>
              <input nz-input #nameInput="ngModel" [name]="'label' + i" type="text" [(ngModel)]="item.label" />
            </td>
            <td>
              <input nz-input #nameInput="ngModel" [name]="'value' + i" type="text" [(ngModel)]="item.value" />
            </td>
            <!-- <td>
                        <input nz-input #nameInput="ngModel" [name]="'desc' + i" type="text" [(ngModel)]="item.desc" />
                    </td> -->
            <td>
              <button nz-button type="link" (click)="deleteRow(i)">删除</button>
            </td>
          </tr>
        </ng-container>
      </nz-table>
      <button nz-button (click)="addRow()">添加列</button>
    </nz-form-control>
  </nz-form-item>
</ng-container>
